/**
 * Normalises a user-entered website URL into an absolute external URL.
 *
 * Returns `undefined` for empty/whitespace-only input so callers can hide the
 * link entirely.
 */
export function toExternalUrl(url: string | undefined): string | undefined {
  const trimmed = url?.trim();
  if (!trimmed) {
    return undefined;
  }
  return /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;
}
